module.exports = __webpack_public_path__ + "img/huang.54a9ad4c.png";